module.exports = __webpack_public_path__ + "static/media/logo.0f22293f.png";